<template>
  <v-autocomplete
      v-model="lgota"
      :items="lgotas"
      :loading="isLoading"
      :item-text="lgota => lgota.id"
      :item-value="lgota => lgota.id"
      :clearable="false"
      :dense="true"
      :no-filter="true"
      :allow-overflow="false"
      @change="onChange"
      class="mt-4"
      outlined
  >
    <template v-slot:no-data>
      <v-list-item> По данному фильтру нет данных</v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>

export default {
  name: "SelectInvoiceCatalogLgota",
  data() {
    return {
      lgota: null,
      isLoading: false,
      lgotas: []
    };
  },
  props: {
    catalogCode: {
      type: Object,
      default: null
    }
  },
  methods: {
    onChange() {
      this.$emit("input", this.lgota);
      this.$emit("change", this.lgota);
    },
    load() {
    /* eslint-disable */
      if (this.catalogCode && this.catalogCode.lgotas) {
        this.lgotas = this.catalogCode.lgotas
      } else {
        this.lgota = null
      }

    },
  },
  created() {
    this.load()
  },
  watch: {
    catalogCode() {
      this.lgotas = []
      this.load()
    }
  }
}
</script>

<style scoped>

</style>